import React from "react";
import { Form, Button } from "react-bootstrap";
import axios from "axios";
import Loader from "../../components/Loader";

const BrandForm = ({
  productData,
  setProductData,
  handleInputChange,
  handleFormattedChange,
  uploading,
  setUploading,
  userInfo,
  onSubmit,
  disable,
  setDisable,
}) => {
  const { image, brand, description } = productData;

  const uploadFileHandler = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("image", file);
    setUploading(true);

    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.post("/api/upload", formData, config);
      setProductData({
        ...productData,
        image: data,
      });
      setUploading(false);
      setDisable(true);
    } catch (error) {
      console.error(error);
      setUploading(false);
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      <Form.Group controlId='name'>
        <Form.Label>Type of Image</Form.Label>
        <Form.Select required type='name' onChange={handleInputChange}>
          <option value='' hidden>
            Select
          </option>
          <option value='BrandImage'>Brand Image</option>
        </Form.Select>
      </Form.Group>

      <Form.Group controlId='image' className='mb-3'>
        <Form.Label>Brand Image</Form.Label>
        <Form.Control
          type='text'
          required
          placeholder='Enter image url'
          value={image}
          disabled={disable}
          onChange={handleInputChange}
        />
        <Form.Control
          type='file'
          id='image-file'
          label='Choose File'
          accept='.jpg, .jpeg, .png'
          onChange={uploadFileHandler}
          className='mt-2'
        />
        {uploading && <Loader />}
      </Form.Group>

      <Form.Group controlId='brand' className='mb-3'>
        <Form.Label>Brand Name(whose image we require)</Form.Label>
        <Form.Control
          required
          type='text'
          placeholder='Enter brand'
          value={brand}
          onChange={handleFormattedChange}
        />
      </Form.Group>

      <Form.Group controlId='category'>
        <Form.Label>Select Category</Form.Label>
        <Form.Select
          onChange={handleInputChange}
          required
          onInvalid={(e) => {
            e.target.setCustomValidity("Please Choose this");
          }}
          onInput={(e) => {
            e.target.setCustomValidity("");
          }}
        >
          <option value='' hidden>
            Select
          </option>
          <option value='EyeglassesBrand'>Eyeglasses Brand</option>
          <option value='SunglassesBrand'>Sunglasses Brand</option>
          <option value='ContactlensBrand'>Contactlens Brand</option>
        </Form.Select>
      </Form.Group>

      <Form.Group controlId='description' className='mb-3'>
        <Form.Label>Description</Form.Label>
        <Form.Control
          required
          as='textarea'
          rows={3}
          placeholder='Enter description'
          value={description}
          onChange={handleInputChange}
        />
      </Form.Group>

      <Button type='submit' variant='primary' className='mt-3'>
        Add Brand Image
      </Button>
    </Form>
  );
};

export default BrandForm;
